import React, {useState, useEffect} from 'react';
import { formatDate } from 'react-day-picker/moment';

import Note from '../../../components/note';
import Label from '../../../components/label';
import FilterButton from '../../../components/filter-button';
import TextNumber from '../../../components/text-number';
import DayPicker from '../../../components/day-picker';
import LinkButton from '../../../components/link-button';
import {getData} from '../../../helper/request-response';
import constant from '../../../config/constant';
import cashLoanPath from './config';

const List = () => {

    const [cashLoans, setCashLoans] = useState([]);

    const getDetailPath = (invoiceNo) => cashLoanPath.detailPath.replace(":id", invoiceNo);

    const [cashLoanFilter, setFilterCashLoan] = useState({
        trxDate: "",
        customerName: ""
    });

    const onInputChange = e => {

        setFilterCashLoan({ 
            ...cashLoanFilter,
            [e.target.name]: e.target.value
        });
    };

    const onSubmit = e => {

        e.preventDefault();

        const params = { 
            params: {
                trxDate: cashLoanFilter.trxDate,
                customerName: cashLoanFilter.customerName,
            }
        };

        getCashLoans(params);

    };

    const getCashLoans = async(params) => {

        const result = await getData(cashLoanPath.baseApi, params);
            
        setCashLoans(result);

    }

    const onDayChange = day => {

        setFilterCashLoan(trx => ({ 
            ...trx,
            trxDate: formatDate(day, constant.DEFAULT_DATE)
        }));
    }

    const onReset = e => {

        e.preventDefault();

        setFilterCashLoan(trx => ({ 
            ...cashLoanFilter,
            trxDate: "",
            customerName: ""
        }));

        getCashLoans();

    }

    useEffect(() => { 

        getCashLoans();

     }, []);
    

    return(
        <React.Fragment>
            <div className="card-header">
                <h3 className="h6 text-uppercase mb-0">{cashLoanPath.title}</h3>
            </div>
            <div className="card-body">
            <div className="row">
                    <div className="col-md-8 border-right">
                        <form className="form-horizontal" onSubmit={ e => onSubmit(e) } >

                            <div className="form-group row">
                                <Label htmlFor="trx-date" isCol={ true } text="Tanggal Pembelian" />
                                <div className="col-md-9">
                                    <DayPicker id="trx-date" name="trxDate" onDayChange={ onDayChange } />
                                </div>
                            </div>

                            <div className="form-group row">
                                <Label htmlFor="cashLoan-customerName" isCol={ true } text="Nama Pelanggan" />
                                <div className="col-md-9">
                                    <input 
                                        id="cashLoan-customerName" 
                                        type="text" 
                                        className="form-control"
                                        name="customerName"
                                        value={ cashLoanFilter.customerName }
                                        onChange={ e => onInputChange(e) } />
                                </div>
                            </div>

                            <div className="form-group row">
                                <Label isCol={ true } />
                                <div className="col-md-9">
                                    <FilterButton to={ cashLoanPath.newPath } newLabel="Tambah Pinjaman Baru" onClick={ onReset } />
                                </div>
                            </div>

                        </form>
                    </div>

                    <div className="col-md-4">
                        <Note isFilter={ true } label="Tambah Transaksi Baru" entity="Transaksi" />
                    </div>
                </div>

                <div className="col-lg-12 mb-4">
                    <div className="row">
                        <table className="table table-striped table-hover card-text">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Tanggal</th>
                                    <th>Nama Pelanggan</th>
                                    <th>Deskripsi</th>
                                    <th>Total</th>
                                    <th>Opsi</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    cashLoans.map((cashLoan, index) => {
                                        const ket = cashLoan.description.split('-');
                                        return(
                                            <tr key={index}>
                                                <th scope="row">{ index + 1 }</th>
                                                <td>{ `${formatDate(cashLoan.trxDate, 'LL', constant.LOCALE)}` }</td>
                                                <td>{ cashLoan.custName }</td>
                                                <td>{ ket.length > 1 ? ket[1] : 'PIUTANG PELANGGAN' }</td>
                                                <td><TextNumber value={ cashLoan.amount } /></td>
                                                <td><LinkButton to={ {pathname: getDetailPath(cashLoan.invoiceNo), state: cashLoan} } /></td>
                                            </tr>
                                        );
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default List;
